const LOCALSTORAGE_TOKEN_KEY = 'token';

export const getToken = () => {
    const tokenString = localStorage.getItem(LOCALSTORAGE_TOKEN_KEY);
    /*    const userToken = JSON.parse(tokenString);*/
    return JSON.parse(tokenString ?? "");
};

/*    const [token, setToken] = useState(getToken());*/

export const saveToken = userToken => {
    localStorage.setItem(LOCALSTORAGE_TOKEN_KEY, JSON.stringify(userToken));
};

export const clearToken = userToken => {
    localStorage.removeItem(LOCALSTORAGE_TOKEN_KEY);
};

/*export default Token;*/